import React from 'react';

import LinkMore from '@app/components/UI/LinkMore/LinkMore';
import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import imagePlaceholder from '@app/images/image-placeholder.png';
import { Image } from '@app/objects/Image';
import { LinkBlockItemRich } from '@app/objects/LinkBlockItem';
import { WithPath } from '@app/objects/WithPath';
import '@app/scss/components/linkBlockRich.scss';

const arrow = require('@app/images/arrow_circle.svg');

interface BlockRichProps {
	title: string | React.ReactElement;
	text?: string | React.ReactElement;
	subtitle?: string;
	images?: [Image, Image, Image];
	links?: Array<LinkBlockItemRich>;
	buttonCaption?: string;
	linkMoreCaption?: Array<WithPath>;
	name?: string;
	blockClassName?: string;
	link?: string;
	refBlockRich?: any;
}

const BlockRich: React.FC<BlockRichProps> = ({ link = '', ...props }) => (
	<section className={`link-block-rich ${props.blockClassName ? props.blockClassName : ''}`} id={props.name} ref={props.refBlockRich!}>
		<div className="link-block-rich__block-left">
			<div className="link-block-rich__wrapper">
				<header className="link-block-rich-header">
					{props.subtitle && <h6 className="link-block-rich-header__subtitle">{props.subtitle}</h6>}
					<h2 className="link-block-rich-header__title">{props.title}</h2>
				</header>
				{props.text && (
					<div className="link-block-rich__descr">
						<p>{props.text}</p>
						{props.linkMoreCaption && props.linkMoreCaption.length > 1 && (
							<>
								{props.linkMoreCaption[0] && (
									<LinkMore linkMoreCaption={props.linkMoreCaption[0].name} linkMoreHref={props.linkMoreCaption[0].path} />
								)}
								{props.linkMoreCaption[1] && (
									<LinkMore linkMoreCaption={props.linkMoreCaption[1].name} linkMoreHref={props.linkMoreCaption[1].path} />
								)}
							</>
						)}
						{props.linkMoreCaption && props.linkMoreCaption.length === 1 && (
							<a href={props.linkMoreCaption[0].path} target="_blank" className="link-more" rel="noopener noreferrer">
								<span>{props.linkMoreCaption[0].name}</span>
								<img src={arrow} alt="arrow" className="link-more-img" />
							</a>
						)}
					</div>
				)}
				{props.buttonCaption && (
					<a className="link-block-rich__link-donate" href={link} target="_blank" rel="noopener noreferrer">
						<button className="btn btn-md btn-primary">{props.buttonCaption}</button>
					</a>
				)}
			</div>
		</div>
		{props.images && (
			<div className="link-block-rich__block-right">
				<div className="link-block-rich-col link-block-rich-col_double">
					{props.images.slice(0, 2).map((image: Image, key: number) => (
						<a href={image.link} key={key}>
							<figure className="image-wrapper">
								<span className="image-wrapper__inner">
									<CustomAvatar
										className="image-wrapper__img"
										src={image.src}
										alt={image.alt || ''}
										errorAvatar={imagePlaceholder}
									/>
								</span>
								<figcaption className="image-wrapper__title">{image.title}</figcaption>
							</figure>
						</a>
					))}
				</div>
				<div className="link-block-rich-col link-block-rich-col_single">
					<a href={props.images[2].link}>
						<figure className="image-wrapper">
							<span className="image-wrapper__inner">
								<CustomAvatar
									className="image-wrapper__img"
									src={props.images[2].src}
									alt={props.images[2].alt || ''}
									errorAvatar={imagePlaceholder}
								/>
							</span>
							<figcaption className="image-wrapper__title">{props.images[2].title}</figcaption>
						</figure>
					</a>
				</div>
			</div>
		)}
	</section>
);

export default BlockRich;
